/**
 * Order Expiration Utility
 * 
 */
import moment from 'moment';
const EXPIRATION_MINUTES = 1440; // 24 hours

/**
 * Check if order has expired (24 hours since creation)
 * @param created_at - Unix timestamp string
 * @returns boolean - true if order has expired
 */
export function isOrderExpired(created_at) {
  if (!created_at) return false;
  const timestamp = parseInt(created_at, 10);
  if (isNaN(timestamp)) return false;
  const createdTime = moment.unix(timestamp);
  if (!createdTime.isValid()) return false;
  const now = moment();
  return now.diff(createdTime, 'minutes') >= EXPIRATION_MINUTES;
}

/**
 * Get milliseconds until order expires
 * @param created_at - Unix timestamp string
 * @returns number - milliseconds until expiration, or 0 if already expired
 */
export function getTimeUntilExpiration(created_at) {
  if (!created_at) return 0;
  const timestamp = parseInt(created_at, 10);
  if (isNaN(timestamp)) return 0;
  const createdTime = moment.unix(timestamp);
  if (!createdTime.isValid()) return 0;
  const expirationTime = createdTime.add(EXPIRATION_MINUTES, 'minutes');
  const now = moment();
  const msRemaining = expirationTime.diff(now);
  return msRemaining > 0 ? msRemaining : 0;
}